
import {
  DevFunction, ObjectObject, verifyTypes, getString, RuntimeError,
} from "../../../interpreting/ScriptInterpreter.js";
import {
  DOMNodeObject, clearAttributes, validateJSXInstance, CLASS_NAME_REGEX
} from "../jsx_components.js";
import {getID} from "./getID.js";


export const render = new DevFunction(
  "InputRange.render", {typeArr: ["object?"]},
  function(
    {callerNode, execEnv, interpreter, thisVal},
    [props = {}]
  ) {
    validateJSXInstance(thisVal, "InputRange", callerNode, execEnv);
    if (props instanceof ObjectObject) {
      props = props.members;
    }
    let {className, idKey, min, max, value, step, onChange, onInput} = props;
    verifyTypes(
      [min, max, value, step, onChange, onInput],
      ["number?", "number?", "number?", "number?", "function?", "function?"],
      callerNode, execEnv
    );
    let id = idKey === undefined ? undefined : getID(idKey);

    // Create the DOM node if it has no been so already.
    let jsxInstance = thisVal.jsxInstance;
    let domNode = jsxInstance.domNode;
    if (!domNode || domNode.tagName !== "INPUT") {
      domNode = document.createElement("input");
      if (value !== undefined) domNode.setAttribute("value", value);
    }
    else {
      clearAttributes(domNode, ["type", "value", "min", "max", "step"]);
    }
    if (className) {
      className = getString(className, callerNode, execEnv);
      if (!CLASS_NAME_REGEX.test(className)) throw new RuntimeError(
        `Invalid class name: "${className}"`,
        callerNode, execEnv
      );
      domNode.setAttribute("class", className);
    }
    domNode.setAttribute("type", "range");
    domNode.setAttribute("class", "input-range");
    if (id !== undefined) domNode.setAttribute("id", id);
    if (min !== undefined) domNode.setAttribute("min", min);
    if (max !== undefined) domNode.setAttribute("max", max);
    if (step !== undefined) domNode.setAttribute("step", step);

    // Set the onchange event if props.onChange is supplied.
    if (onChange) {
      domNode.onchange = (event) => {
        let {value} = event.target;
        let e = {value: value};
        interpreter.executeFunctionOffSync(
          onChange, [e], callerNode, execEnv, thisVal
        );
      };
    }

    // Set the oninput event if props.onInput is supplied.
    if (onInput) {
      domNode.oninput = (event) => {
        let {value} = event.target;
        let e = {value: value};
        interpreter.executeFunctionOffSync(
          onInput, [e], callerNode, execEnv, thisVal
        );
      };
    }

    return new DOMNodeObject(domNode);
  }
);


export const methods = [
  "getValue",
  "setValue",
  "clear",
  "focus",
  "blur",
];

export const actions = {
  "getValue": new DevFunction(
    "getValue", {}, function({thisVal, callerNode, execEnv}, []) {
      validateJSXInstance(thisVal, "InputRange", callerNode, execEnv);
      return thisVal.jsxInstance.domNode.value;
    }
  ),
  "setValue": new DevFunction(
    "setValue", {typeArr: ["number"]},
    function({thisVal, callerNode, execEnv}, [val]) {
      validateJSXInstance(thisVal, "InputRange", callerNode, execEnv);
      let domNode = thisVal.jsxInstance.domNode;
      domNode.value = val;
    }
  ),
  "clear": new DevFunction(
    "clear", {}, function({thisVal, callerNode, execEnv}, []) {
      validateJSXInstance(thisVal, "InputRange", callerNode, execEnv);
      let domNode = thisVal.jsxInstance.domNode;
      let initVal = parseFloat(domNode.getAttribute("value"));
      if (Number.isNaN(initVal)) return;
      domNode.value = initVal;
    }
  ),
  "focus": new DevFunction(
    "focus", {}, function({thisVal, callerNode, execEnv}, []) {
      validateJSXInstance(thisVal, "InputRange", callerNode, execEnv);
      let {jsxInstance} = thisVal;
      if (jsxInstance.canGrabFocus()) {
        thisVal.jsxInstance.domNode.focus();
        return true;
      }
      else {
        return false;
      }
    }
  ),
  "blur": new DevFunction(
    "blur", {}, function({thisVal, callerNode, execEnv}, []) {
      validateJSXInstance(thisVal, "InputRange", callerNode, execEnv);
      thisVal.jsxInstance.domNode.blur();
    }
  ),
};